var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['pt-checkbox']},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"checkbox-border"},[(
          item.value
            ? (_vm.value && _vm.value.indexOf(item.value) > -1) ||
              _vm.value === item.value
            : (_vm.value && _vm.value.indexOf(item) > -1) || _vm.value === item
        )?_c('span',[_vm._v("√")]):_vm._e()]),_vm._v(" "+_vm._s(item.label ? item.label : item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }